var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c(
      "header",
      [
        _c("main-header", {
          attrs: { notificacao: false, hasListagemModelo: false }
        })
      ],
      1
    ),
    _c("div", { staticClass: "container-conversa" }, [
      _c(
        "div",
        { staticClass: "card fullWidth cardPadding" },
        [
          _vm.idConversa
            ? _c("informacoes-conversa", {
                attrs: { idConversa: _vm.idConversa },
                on: { conversa: _vm.setConversa }
              })
            : _vm._e(),
          _c(
            "el-col",
            { staticClass: "container-input" },
            [
              _c("validation-provider", {
                attrs: { rules: "required", name: "Mensagem", mode: "eager" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Mensagem:", required: true }
                        }),
                        _vm.assuntoConversa ===
                        "Solicitação de cópia do processo"
                          ? _c("div", { staticClass: "sugestao" }, [
                              _c("span", [
                                _vm._v(
                                  "Sugestão de resposta ao Consultor Externo - Diverso: Favor enviar o comprovante de pagamento do boleto em resposta à essa mensagem."
                                )
                              ])
                            ])
                          : _vm._e(),
                        _c("app-text-editor", {
                          class: {
                            "input erro":
                              errors && errors.length > 0 ? true : false
                          },
                          attrs: { config: _vm.config },
                          model: {
                            value: _vm.conversa.mensagem,
                            callback: function($$v) {
                              _vm.$set(_vm.conversa, "mensagem", $$v)
                            },
                            expression: "conversa.mensagem"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "drop" },
            [
              _c("app-anexo", {
                attrs: { id: "upload-atualizacao-base", files: _vm.anexos },
                on: {
                  uploadFile: _vm.uploadFile,
                  removeFile: _vm.removeFile,
                  downloadDocumentoCadastro: _vm.getDownload
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            [
              _c("app-buttons-cadastro", {
                staticClass: "btns",
                attrs: {
                  isPrimeiroPasso: true,
                  isUltimoPasso: true,
                  showButtonFinalizar: false,
                  showButtonEnviar:
                    (!!_vm.idConversa || !!_vm.conversa.assunto) &&
                    !!_vm.conversa.mensagem,
                  showButtonDownload: _vm.isAmapa
                },
                on: {
                  cancelar: _vm.cancelar,
                  download: _vm.download,
                  enviar: _vm.enviar
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88de4d12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88de4d12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ouvidoria/ResponderConversa.vue
// module id = null
// module chunks = 